import { CommonModule } from '@angular/common';
import { Component, inject, signal, computed } from '@angular/core';
import {
	RouterModule, Router
} from '@angular/router';
import { SiteStore } from 'src/app/store/site.store';
import { BottomBarComponent } from '../../../components/layout/bottomBar/bottomBar.component';
import { DrawerComponent } from '../../../components/layout/drawer/drawer.component';
import { NavbarComponent } from '../../../components/layout/navbar/navbar.component';
import { AuthStore } from 'src/app/store/auth.store';
import { TransactionTypesStore } from 'src/app/store/transaction-types.store';
import { ViewModeStore } from 'src/app/store/view-mode.store';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [RouterModule, CommonModule, NavbarComponent, BottomBarComponent, DrawerComponent],
  templateUrl: './dashboard.component.html'
})
export class DashboardLayoutComponent {
  containerClass: string = 'max-w-xl';
  bigHeader: boolean = false;
  siteStore = inject(SiteStore);
	authStore = inject(AuthStore);
	transactionTypeService = inject(TransactionTypesStore);
	viewModeStore = inject(ViewModeStore);
	router = inject(Router);

	public isDesktopDevice = signal<boolean>(false); // Add signal to track device type

	// Computed property para obtener la clase del contenedor según el modo de vista
	containerClassComputed = computed(() => {
		const customClass = this.siteStore.routeMetadata().containerClass;
		if (customClass) return customClass;
		
		const currentUrl = this.router.url;
		
		// Solo aplicar el modo tabla si estamos en la ruta correspondiente
		const isTransactionsRoute = currentUrl.includes('/transactions');
		const isPaymentsRoute = currentUrl.includes('/payments');
		
		if (isTransactionsRoute && this.viewModeStore.isTransactionsTableView()) {
			return '!px-8 pt-16';
		}
		
		if (isPaymentsRoute && this.viewModeStore.isPaymentsTableView()) {
			return '!px-8 pt-16';
		}
		
		return 'sm:max-w-xl sm:pt-16';
	});

	// Clase del wrapper externo. En las páginas de docs el fondo debe ser blanco
	// completo (sin el gradiente del dashboard).
	wrapperClassComputed = computed(() => {
		// Leer routeMetadata() para que el computed se recalcule en cada navegación.
		this.siteStore.routeMetadata();

		const isDocsRoute = this.router.url.includes('/docs');
		if (isDocsRoute) {
			return 'min-h-full bg-white';
		}

		return 'min-h-full sm:bg-gradient-to-t sm:from-white sm:via-white sm:to-primary-200';
	});

	constructor() {
		this.transactionTypeService.loadTransactionTypes();
		
		this.checkDeviceType()
	}

	private checkDeviceType() {
		const userAgent = navigator.userAgent;
		// RegExp to check for mobile devices
		const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
		this.isDesktopDevice.set(!mobileRegex.test(userAgent));
	}

}
